































































































































import {
  apiOrderOrderCancel,
  apiOrderOrderConfirm,
  apiOrderOrderDelete,
  ApiOrderOrderDeliverDetailResponse,
  apiOrderOrderPay,
  apiOrderOrderUrged,
} from '@/api'
import { computed } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent } from '@/hooks'
import { Dialog } from 'vant'
import { getCurrentPageUrl, navigateTo } from '@/router'
import { globalModel } from '@/model'
import { onPageVisibilityChange, submit } from '@/utils'
import { RequiredDeep } from 'vtils/types'
import { wait } from 'vtils'

export default defineClassComponent<{
  value: RequiredDeep<ApiOrderOrderDeliverDetailResponse>
  fromDetail: boolean
}>(
  {
    props: ['value', 'fromDetail'],
  },
  ({ props, ctx }) =>
    class {
      item = computed(() => props.value)

      // 订单状态
      status = computed(() => props.value.status)

      // 是否组合订单
      isJoint = computed(() => props.value.orderClassify === 5)

      // 点击取消订单
      handleCancelClick = () => {
        submit(async $ => {
          await Dialog.confirm({
            title: '温馨提示',
            message: '确定取消此订单吗？',
          })
          await $.start()
          await apiOrderOrderCancel({
            orderNo: props.value.orderNo,
          })
          ctx.$emit('refresh')
          await $.success('取消成功')
        })
      }

      // 去支付
      handlePayClick = () => {
        submit(async $ => {
          await $.start()
          const payData = await apiOrderOrderPay({
            orderNo: props.value.orderNo,
            payType: globalModel.state.payType as any,
            openId: globalModel.state.openid,
          })
          if (Number(payData.payType) === 12) {
            // @ts-ignore
            const payUrl = payData.thirdParams.payUrl.replace(
              'SUCURL',
              encodeURIComponent(getCurrentPageUrl()),
            )
            const off = onPageVisibilityChange(visible => {
              if (visible) {
                off()
                ctx.$emit('refresh')
              }
            })
            dcb.navigateTo({
              url: payUrl,
            })
          } else {
            await dcb.requestPayment({
              provider: 'native',
              showNativeResultPage: false,
              params: payData,
            })
            await wait(2000)
            ctx.$emit('refresh')
            await $.success('支付成功')
          }
        })
      }

      // 点击删除订单
      handleDeleteClick = async () => {
        await submit(async $ => {
          await Dialog.confirm({
            title: '温馨提示',
            message: '确定删除此订单吗？',
          })
          await $.start()
          await apiOrderOrderDelete({
            orderNo: props.value.orderNo,
          })
          ctx.$emit('refresh', {
            trigger: 'delete',
          })
          await $.success('删除成功')
        })
      }

      // 点击提醒接单
      handleRemindClick = async () => {
        await submit(async $ => {
          await $.start()
          await apiOrderOrderUrged({
            orderNo: props.value.orderNo,
          })
          ctx.$emit('refresh')
          await $.success('提醒接单成功')
        })
      }

      // 申请退款
      handleRequestRefundClick = () => {
        navigateTo('BookRefundRequest', {
          orderNo: props.value.orderNo,
        })
      }

      // 配送详情
      handleDeliveryClick = () => {
        navigateTo('ExpressIndex', {
          orderNo: props.value.orderNo,
        })
      }

      // 查看详情
      handleDetailClick = () => {
        navigateTo('InstantDeliveryOrderDetail', {
          orderNo: props.value.orderNo,
        })
      }

      // 去评价
      handleCommentClick = () => {
        navigateTo('OrderComment', {
          orderNo: props.value.orderNo,
        })
      }

      // 点击确认收货
      handleConfirmClick = async () => {
        await submit(async $ => {
          await Dialog.confirm({
            title: '温馨提示',
            message: '确认已经收到货物了吗？',
            cancelButtonText: '暂未',
            confirmButtonText: '确认收到',
          })
          await $.start()
          await apiOrderOrderConfirm({
            orderNo: props.value.orderNo,
          })
          ctx.$emit('refresh')
          await $.success('确认收货成功')
        })
      }

      // 再来一单
      handleAgainClick = () => {
        navigateTo('InstantDeliveryMartIndex', {
          martId: props.value.merchantId,
        })
      }

      // 申请售后
      handleRefundRequestClick = () => {
        navigateTo('AfterSalesRequestSubmit', {
          orderNo: props.value.orderNo,
          fromInstantDelivery: true,
        })
      }

      // 售后详情
      handleRefundDetailClick = () => {
        navigateTo('AfterSalesDetail', {
          id: props.value.commodities[0].saleAfterId,
          fromInstantDelivery: true,
        })
      }
    },
)
